// ORKSTRA Theme — type definitions
// Re-exports the canonical ColorMode / ThemePreference from design-tokens
// so consumers depend on lib/theme rather than the raw tokens module.

import type { ColorMode, ThemePreference } from '@/styles/design-tokens'

export type { ColorMode, ThemePreference }

export const THEME_STORAGE_KEY = 'orkstra-theme'

export interface ThemeContextValue {
  preference: ThemePreference
  mode: ColorMode
  systemMode: ColorMode
  isAuto: boolean
  setPreference: (next: ThemePreference) => void
}
